import { brand } from "../../../context";
import { StatusTag, ViewOfferButton } from "./components";

type QuotationRequestMobileTableProps = {
  quotations: any[];
};

export function QuotationRequestMobileTable({ quotations }: QuotationRequestMobileTableProps) {
  return (
    <table className="Table Quotations__body__mobiletable" data-brand={brand}>
      <thead>
        <tr>
          <th className="text-left!">Reference</th>
          <th className="text-left!">Title</th>
          <th className="text-left!">Status</th>
        </tr>
      </thead>
      <tbody>
        {quotations.map((q: any, idx: number) => {
          return (
            <tr key={`${idx}-${q.reference}`} className="odd:bg-gray-100">
              <td className="text-xs text-left!">{q?.reference}</td>
              <td className="text-xs text-left!">{q?.title || "N/A"}</td>
              <td className="text-xs text-left!">
                {!!q?.offer_reference ? (
                  <ViewOfferButton offerReference={q.offer_reference} />
                ) : (
                  <StatusTag hasOffer={false} status={q.status} statusDisplay={q.status_display} />
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
